import { render, staticRenderFns } from "./CoVideo.vue?vue&type=template&id=6dd62d01&scoped=true&"
import script from "./CoVideo.vue?vue&type=script&lang=js&"
export * from "./CoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd62d01",
  null
  
)

export default component.exports